import { create } from "zustand";
import type { IProposalSocials } from "../hooks/http/admin/proposal-creators/add-proposal-social.admin.http";

interface IProposalSocialsStore {
  data: IProposalSocials[];
  setData: (data: IProposalSocials[]) => void;
  removeById: (id: string) => void;
  updateInternalCost: (id: string, cost: number) => void;
  updateExternalCost: (id: string, cost: number) => void;
  markCommentsRead: (id: string, user: string) => void;
  updateCommentCount: (id: string, count: number) => void;
}

const useProposalSocialStore = create<IProposalSocialsStore>((set) => ({
  data: [],
  setData: (data: IProposalSocials[]) => set(() => ({ data })),
  updateInternalCost: (id: string, cost: number) =>
    set((state) => ({
      data: state.data.map((item) => {
        if (item.proposalSocial?.id === id && item.proposalSocial?.fixedPayout) {
          item.proposalSocial.fixedPayout.amount = cost;
        }
        return item;
      }),
    })),
  updateExternalCost: (id: string, cost: number) =>
    set((state) => ({
      data: state.data.map((item) => {
        if (item.proposalSocial?.id === id && item.proposalSocial?.fixedPayoutAmount) {
          item.proposalSocial.fixedPayoutAmount.amount = cost;
        }
        return item;
      }),
    })),

  removeById: (id: string) =>
    set((state) => ({
      data: state.data.filter((user) => user.proposalSocial?.id !== id),
    })),
  markCommentsRead: (id: string, user: string) =>
    set((state) => ({
      data: state.data.map((item) => {
        if (item.proposalSocial?.id === id) {
          item.proposalSocial.commentReadByUsersList.push(user);
        }
        return item;
      }),
    })),
  updateCommentCount: (id: string, count: number) =>
    set((state) => ({
      data: state.data.map((item) => {
        if (item.proposalSocial?.id === id) {
          item.proposalSocial.commentCount = count;
        }
        return item;
      }),
    })),
}));

export default useProposalSocialStore;
